import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { CLIENT_SUBSCRIPTIONS } from 'src/constants/constants';
import useHasPermissions from 'src/hooks/useHasPermission';

const EdrPreviewDataBanner: FC = () => {
  const { t } = useTranslation('securityEdr');
  const checkPermissions = useHasPermissions();
  const canViewSubscriptions = checkPermissions([CLIENT_SUBSCRIPTIONS]);

  return (
    <Box mb={2}>
      <Alert severity="info" variant="outlined">
        {t('previewBanner.message')}
        {canViewSubscriptions ? (
          <>
            {' '}
            <Link component={RouterLink} to="/subscriptions" underline="hover">
              {t('previewBanner.cta')}
            </Link>
          </>
        ) : null}
      </Alert>
    </Box>
  );
};

export default EdrPreviewDataBanner;
